export default [
    {
        path: 'relatorio-solicitacao',
        component: () => import(
            /* webpackChunkName: 'regulacao-relatorio-solicitacao' */
            '@/views/regulacao/relatorio-solicitacao/Index'
        ),
        redirect: 'relatorio-solicitacao/index',
        children: [
            {
                name: 'regulacao-relatorio-solicitacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'regulacao-relatorio-solicitacao' */
                    '@/views/regulacao/relatorio-solicitacao/List.vue'
                ),
            },
        ],
    },
]